//
import { FormViewMixin } from '@/mixins/reusable_mixins'
import translator from '@/services/translator'

//
import RepackingHistoricModel from '@/models/Warehouse/WhRepackingHistoric'
import fields from './fields'

//
export default {
    name: 'repacking-historic-create',
    computed: {
        
        /**
         * @description
         * RForm props.
         *
         * @return  {Object}
         */
        formProps() {
            return {
                fields//RepackingHistoricFields.readonly(),
            }
        },

        /**
         * @description
         * View title
         *
         * @return  {String}
         */
        title() {
            return 'Crear reenvasado'
        },
    },
    data() {
        return {
            formData: {},
        }
    },
    methods: {

        /**
         * @description
         * Redirect to repacking historic list.
         */
        redirect() {
            this.$router.push({ name: 'repacking-historic' })
        },

        /**
         * @description
         * Resets the view.
         */
        reset() {
            this.formData = new RepackingHistoricModel()
        },

        /**
         * @description
         * Shows the error.
         *
         * @param   {Object}    error   The error response request
         * @return  {Promise}  
         */
        showError(error) {
            return this.showErrorSnackbar(translator(RepackingHistoricModel, error.response.data))
        },

        /**
         * @description
         * Shows the success.
         *
         * @return  {Promise}
         */
        showSuccessCreate() {
            return this.showSuccessSnackbar('Reenvasado agregado.')
        },

        /**
         * @description
         * Submit the create process.
         */
        submitCreate() {
            this.toWait(true)
                .then(this.toCreate)
                .then(this.toWait)
        },

        /**
         * @description
         * Send the create request.
         *
         * @param   {Object}  model   The repacking historic model
         * @return  {Promise}
         */
        toCreate(model) {
            return model
                .toCreate()
                .save()
                .then(this.showSuccessCreate)
                .then(this.redirect)
                .catch(this.showError)
        },
    },
    mixins: [
        FormViewMixin,
    ],
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_PRODUCT_REPACKING')) ctx.$router.push('/')
        })
    },
}
